import { useEffect } from 'react';

/**
 * 文档标题（浏览器标签页）统一管理。
 *
 * 站点为 SPA，路由切换不会重置 document.title——若不主动设置，所有页面标签页都显示
 * 初始的「知行经管数据」，用户开多标签页会迷失。这里提供统一格式与 hook：
 *   - 内页：`<页面名> · 知行经管数据`
 *   - 首页：`知行经管数据 · 经管研究数据下载平台`
 *
 * 静态路由由 <RouteTitle> 集中按 pathname 设置；数据驱动页（数据集详情、搜索）
 * 在数据就绪后用本 hook 覆盖为更精确的标题（数据集名 / 搜索词）。
 */

export const SITE_NAME = '知行经管数据';
const SITE_TAGLINE = '经管研究数据下载平台';

export function formatTitle(page?: string | null): string {
  const p = page?.trim();
  return p ? `${p} · ${SITE_NAME}` : `${SITE_NAME} · ${SITE_TAGLINE}`;
}

/**
 * 把 document.title 设为 `${page} · 知行经管数据`。
 * 传入空 / null / undefined 时不动标签页（让 RouteTitle 的兜底标题保留，
 * 避免数据未就绪时标题闪烁或残留上一页内容）。
 */
export function useDocumentTitle(page?: string | null): void {
  useEffect(() => {
    if (!page || !page.trim()) return;
    document.title = formatTitle(page);
  }, [page]);
}
